/**
 * CDN URL helper.
 *
 * Initialised once on app boot from the `cdnHost` Inertia shared prop
 * (sourced from Rails credentials). When a CDN host is configured,
 * `cdnUrl()` prefixes static asset paths so browsers fetch from the
 * edge instead of the origin.
 *
 * Usage:
 *   cdnUrl("/property-royal-york-800w.webp")
 *   // => "https://cdn.quiteright.co.uk/property-royal-york-800w.webp"
 *   // or just "/property-royal-york-800w.webp" if no CDN is configured
 */

let host = ""

/** Call once during app setup with the shared prop value. */
export function initCdn(cdnHost: string | null | undefined) {
  host = cdnHost ?? ""
}

/** Prefix a path with the CDN host. No-op when CDN is not configured. */
export function cdnUrl(path: string): string {
  return host ? `${host}${path}` : path
}
